import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import './RemoveSpeaker.css'; // Import CSS module
function RemoveSpeaker() {
    const [speakers, setSpeakers] = useState([]);

    useEffect(() => {
        fetchSpeakers();
    }, []);

    const fetchSpeakers = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/speakers`);
            setSpeakers(response.data);
        } catch (error) {
            console.error('Error fetching speakers:', error);
        }
    };

    const removeSpeaker = async (id) => {
        try {
            await axios.delete(`${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/remove/speaker/${id}`);
            Swal.fire('Removed!', 'The speaker has been removed.', 'success');
            // Update the state to reflect the removal
            setSpeakers(speakers.filter(speaker => speaker._id !== id));
        } catch (error) {
            console.error('Error removing speaker:', error);
            Swal.fire('Error', 'Failed to remove the speaker', 'error');
        }
    };
    return (
        <div className="RemoveSpeakerContainer">
          <h2>Speaker List</h2>
          {speakers.map((speaker, index) => (
            <div className="RemoveSpeakerCard" key={index}>
              <div className="RemoveSpeakerDetails">
                <h3 className="RemoveSpeakerName">{speaker.name}</h3>
                <p className="RemoveSpeakerPosition">{speaker.position}</p>
                <p className="RemoveSpeakerType">{speaker.type}</p>
             
              </div>
              <div className="RemoveSpeakerActions">
                <button className="RemoveSpeakerButton" onClick={() => removeSpeaker(speaker._id)}>Remove</button>
              </div>
            </div>
          ))}
        </div>
    );
}


export default RemoveSpeaker;
